import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=dab99e3a&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dab99e3a')) {
      api.createRecord('dab99e3a', component.options)
    } else {
      api.reload('dab99e3a', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=dab99e3a&", function () {
      api.rerender('dab99e3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HMDXg16ISGUz/JS/videoIframe.vue"
export default component.exports